import {
  GET_PAYMENT_SUMMARY_360,
  GET_PAYMENT_SUMMARY_360_SUCCESS,
  GET_PAYMENT_SUMMARY_360_ERROR,
  GET_PAYMENT_SUMMARY_360_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetPaymentSummary360 = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENT_SUMMARY_360:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_PAYMENT_SUMMARY_360_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_PAYMENT_SUMMARY_360_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_PAYMENT_SUMMARY_360_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetPaymentSummary360;
